export * from './delete-konstante.service';
export * from './delete-konstante.service.module';